/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 124 24"
    data-name="SvgRectangle01"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M12 .458h103.007c.518 0 1.002.26 1.287.693L123.45 12l-7.156 10.849a1.54 1.54 0 0 1-1.287.693H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458"
    />
    <path
      fill="url(#rectangle01_svg__a)"
      fillOpacity={0.4}
      d="M12 .458h103.007c.518 0 1.002.26 1.287.693L123.45 12l-7.156 10.849a1.54 1.54 0 0 1-1.287.693H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458"
    />
    <path
      stroke="url(#rectangle01_svg__b)"
      strokeWidth={0.917}
      d="M12 .458h103.007c.518 0 1.002.26 1.287.693L123.45 12l-7.156 10.849a1.54 1.54 0 0 1-1.287.693H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458Z"
    />
    <defs>
      <linearGradient
        id="rectangle01_svg__a"
        x1={34.981}
        x2={40.047}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle01_svg__b"
        x1={9.534}
        x2={13.095}
        y1={0.45}
        y2={28.466}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.2} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.2} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.6} />
      </linearGradient>
    </defs>
  </svg>
)
